var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',[_c('dynamic-zone-renderer',{attrs:{"components":_vm.content.components}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }